<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline row">
                        <div class="col-xs-12 col-sm-fill hidden-xs col-xl-10">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}
                            </h3>
                        </div>
                        <div class="col-xs-12 col-sm-fit col-xl-1">
                            <router-link class="button button-lg color-primary block-mobile" :to="{'name': 'CadastrarUsuarios', 'query': {'t': (new Date().getTime())}}">
                                Adicionar <i class="las la-plus-circle"></i>
                            </router-link>
                        </div>
                    </div>

                    <div class="row margin-top-20">
                        <div class="col-xl-12 margin-bottom-20">
                            <p class="help">
                                <i class="las la-question-circle"></i>
                                Aqui é possível cadastrar e gerenciar todos os usuários operacionais que terão acesso ao sistema.
                            </p>
                        </div>                        
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="form-header margin-bottom-0" v-on:submit.prevent="form.page = 1;get(true);" novalidate="">
                                <div class="flex-xl-nowrap row">
                                    <div class="col-xs-12 col-md-12 col-lg-5 col-xl-fill">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Pesquisa:</h5>
                                            <input type="text" placeholder="Pesquise um usuário aqui.." required="" class="with-border margin-bottom-0" v-model="form.pesquisa">
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-fit">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-fit">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>         
                                    <div class="col-xs-fit float-right">
                                        <div class="submit-field margin-bottom-10">
                                            <h5 style="opacity: 0;" class="hidden-xs">.</h5>
                                            <button class="button color-gray" style="height: 50px; width: 100%;">
                                                <i class="las la-search"></i>
                                            </button>  
                                        </div>
                                    </div>                                    
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>                         
                        </div>                         
                        
                        <div class="col-xl-12 col-xs-12">
                            <div v-show="data.itens.length == 0 && data.loaded">
                                <center>                           
                                    <div class="hidden-xl hidden-lg hidden-md" style="margin-top: 17%"></div>
                                    <img src="static/images/empty.svg" style="width: 300px;">
                                    <h3 class="center" style="line-height: 120%; font-weight: 200">
                                        Nenhum resultado encontrado.
                                    </h3>
                                </center>     
                            </div>   

                            <div class="parent table-scroll margin-top-30" style="overflow-x: auto !important; border: 1px solid #ddd;" v-if="data.itens.length > 0 && data.loaded">
                                <table class="child table table-bordered  table-responsive table-bordered-default">
                                    <thead>
                                        <th style="min-width: 80px; width: 80px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome
                                        </th>
                                        <th style="min-width: 120px; width: 120px;">
                                            Tipo
                                        </th>
                                        <th style="min-width: 200px; width: 200px;">
                                            E-mail
                                        </th>
                                        <th style="min-width: 120px; width: 120px; text-align: center;">
                                            Telefone
                                        </th>                                        
                                        <th style="min-width: 150px; width: 150px; text-align: center;">
                                            Data de criação
                                        </th>
                                        <th style="min-width: 120px; width: 120px; text-align: center;">
                                            Ações
                                        </th>
                                    </thead>
                                    <tbody>   
                                        <tr v-for="(item, index) in data.itens" :key="item.id" v-bind:class="{'bloqueado': item.ativo == -1}">
                                            <td data-label="ID:">
                                                <b>
                                                    #{{item.id}}
                                                </b>
                                            </td>
                                            <td data-label="Nome:" style="">                               
                                                {{item.nome}}
                                            </td>   
                                            <td data-label="Tipo:">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    <span class="dashboard-status-button color-blue">
                                                        {{(item.tipo == 'admin' ? 'Administrador': '')}}
                                                        {{(item.tipo == 'prestador' ? 'Técnico': '')}}
                                                    </span>
                                                </router-link>
                                            </td>   
                                            <td data-label="E-mail:">
                                                {{item.email}}
                                            </td>
                                            <td data-label="Telefone:" style="text-align: center;">
                                                <a>
                                                    {{item.telefone ? item.telefone : '-'}}
                                                </a>
                                            </td>                               
                                            <td data-label="Data de criação:" style="text-align: center;">
                                                {{item.datahora | formatDate}}
                                            </td>
                                            <td data-label="Ações:" style="text-align: center;">
                                                <p class="segmented segmented-raised segmented-round">
                                                    <button v-on:click="$root.go('EditarUsuarios', JSON.stringify({'c': item.cod}))" class="button button-round color-primary">
                                                        <i class="las la-edit"></i>
                                                    </button>
                                                    <button v-if="item.ativo == 1" v-on:click="bloquear(item.cod)" class="button button-round color-orange">
                                                        <i class="las la-ban"></i>
                                                    </button>
                                                    <button v-if="item.ativo == -1" v-on:click="desbloquear(item.cod)" class="button button-round color-orange">
                                                        <i class="las la-check-circle"></i>
                                                    </button>                                                    
                                                    <button v-on:click="del(item.cod)" class="button button-round button-danger color-red">
                                                        <i class="las la-trash"></i>
                                                    </button>
                                                </p>
                                            </td>                 
                                        </tr> 
                                    </tbody>
                                </table>
                            </div>

                            <div class="pagination-container margin-top-60 margin-bottom-60">
                                <nav class="pagination">
                                    <ul>
                                        <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                            <a>
                                                <i class="material-icons">arrow_back</i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                            <a>
                                                Próxima
                                                <i class="material-icons">arrow_forward</i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="(item, index) in data.pages" v-show="item.show">
                                            <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                {{item.index}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Usuarios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1] || "";
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "admin,prestador",
                "page":             1,
                "pesquisa":         ""
            }              
        }
    },
    methods: {
        get: function(noScroll) {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/usuarios.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    resolve(response.data.result);
                    if (!noScroll) self.$root.scrollTop();
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja desativar esse usuário?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/usuarios.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        bloquear: function(cod) {
            console.log("bloquear()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja bloquear?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                form.acao               = "bloquear";
                loading.show();
                
                axios.put("api/usuarios.php", form)
                .then(response => {
                    console.log("bloquear() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("bloquear() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        desbloquear: function(cod) {
            console.log("desbloquear()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja desbloquear?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                form.acao               = "bloquear";
                loading.show();
                
                axios.put("api/usuarios.php", form)
                .then(response => {
                    console.log("desbloquear() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("desbloquear() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }                   
    },
    created: function() {
        var self = this;
        self.get();
    },
    activated: function() {
        var self = this;
        self.get(true);        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .img-perfil {
        width: 50px;
        height: 50px;
        background-size: cover;
        background-position: center;
        border: 1px solid #ddd;
        border-radius: 6px;
        display: inline-block;
    }
    td {
        overflow: hidden;
        /*white-space: pre-wrap;*/
        word-break: break-all;
    }

    td.disabled {
        pointer-events: none !important;
        opacity: 0.5 !important;
    }

    .bloqueado {
        opacity: 0.5 !important;
    }
    
</style>



// WEBPACK FOOTER //
// src/components/Usuarios.vue